import { createContext, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import { PortalProvider } from 'modules/PortalProvider';
import { ToastProvider } from 'modules/Toast';
import { TooltipProvider } from 'modules/Tooltip/TooltipProvider';
import { InterFontFace } from 'modules/tetrisTheme/typography/InterFontFace';
import { ThemeVariables } from './ThemeVariables';
// import { ThemePath } from './themeGet';
import { getTheme } from './themes';
export const TetrisThemeContext = createContext(null);
export function TetrisThemeProvider(props) {
    const { children, theme = 'light' } = props;
    const [themeType, setThemeType] = useState(theme);
    const value = {
        themeType,
        setThemeType,
    };
    const currentTheme = getTheme(themeType);
    return (<TetrisThemeContext.Provider value={value}>
      <ThemeProvider theme={currentTheme}>
        <ThemeVariables $theme={currentTheme}/>
        <InterFontFace />
        <PortalProvider />
        <ToastProvider>
          <TooltipProvider>{children}</TooltipProvider>
        </ToastProvider>
      </ThemeProvider>
    </TetrisThemeContext.Provider>);
}
